export const agentPlayground = {
  header: {
    title: "AI Agent Testing",
    chip: "AI Reception · Beta",
    sub: "Chat with the advanced agent without sending anything over WhatsApp.",
  },
  context: {
    title: "Context",
    listingLabel: "Listing",
    listingPlaceholder: "Select a listing…",
    allListings: "🌐 All accommodations (new bookings)",
    accountModeHint:
      "The agent responds as if it weren't tied to a specific accommodation: ideal for testing booking requests.",
    guestStatusLabel: "Guest status",
    stay: {
      auto: "Automatic",
      inStay: "Currently staying (during the stay)",
      beforeArrival: "Not arrived yet (future booking)",
      after: "Stay finished",
    },
    guestStatusHint: "Simulate the guest's moment to see the different responses.",
    reservationIdLabel: "Booking ID",
    optional: "(optional)",
    reservationIdPlaceholder: "e.g. 1234",
    phoneLabel: "Guest phone",
    phonePlaceholder: "+34...",
    langLabel: "Language",
    lang: {
      auto: "Automatic",
      es: "Spanish",
      en: "English",
      pt: "Portuguese",
      fr: "French",
      de: "German",
      pl: "Polish",
    },
    reset: "Reset conversation",
  },
  debug: {
    resolvedTitle: "Resolved context",
    listing: "Listing",
    property: "Property",
    reservation: "Booking",
    checkin: "Check-in",
    checkout: "Check-out",
    lang: "Language",
    toolsTitle: "Tools used",
  },
  chat: {
    emptyPrompt: "Write a message as if you were the guest.",
    pay: "Pay",
    book: "Book",
    sentAsButton: "On WhatsApp it's sent as a button",
    sentAsList: "On WhatsApp it's sent as a list · {button}",
    inputPlaceholder: "Write a message…",
  },
  suggestions: {
    s1: "What time is check-in?",
    s2: "Is there parking?",
    s3: "Do you have wifi? What's the password?",
    s4: "Can I check in early?",
  },
  errors: {
    loadListings: "Couldn't load the listings.",
    chatError: "Error talking to the agent.",
    chatReplyFallback: "⚠️ I couldn't reply. Check the context or try again.",
  },
  methods: {
    listingFallback: "Listing #{id}",
  },
};
